// extracted by mini-css-extract-plugin
module.exports = {"nomargin":"small-text_nomargin__GzqLf","bulletedList":"small-text_bulletedList__hSwXR","numberedList":"small-text_numberedList__4Ly2n"};